import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { isRussianDomain } from '../config/domainLanguages';

export default function SiteMeta() {
    const { i18n } = useTranslation();

    useEffect(() => {
        const isRu = isRussianDomain();
        const metaDescription = isRu
            ? 'SportProgress — платформа для управления спортивными школами. Расписание, платежи, посещаемость.'
            : 'SportProgress — Sports School Management Platform. Scheduling, payments, attendance tracking for coaches and school owners.';

        document.title = 'SportProgress';
        document.documentElement.lang = (i18n.resolvedLanguage || i18n.language || 'en').split('-')[0];

        const desc = document.querySelector('meta[name="description"]');
        if (desc) desc.setAttribute('content', metaDescription);

        const ogTitle = document.querySelector('meta[property="og:title"]');
        if (ogTitle) {
            ogTitle.setAttribute('content', isRu
                ? 'SportProgress — Управление спортивной школой'
                : 'SportProgress — Sports School Management');
        }
    }, [i18n.language, i18n.resolvedLanguage]);

    return null;
}
